<div class="boxed show-for-m">
  <div class="sticky margin-b-1">
    <app-search-filter></app-search-filter>
  </div>
</div>

<app-collections-list>
  <h1>{{'home.highlight' | i18next}}</h1>
</app-collections-list>
<div class="boxed">
  <h1>{{'home.news' | i18next}}</h1>
  <app-highlight-collection></app-highlight-collection>
</div>
